export default __webpack_public_path__ + "static/media/45-min.50c9e1c5.jpg";